export const classes = (...classNames: string[]): string => {
  return classNames.join(" ");
};
